module.exports = __webpack_public_path__ + "img/setting_btn.e35bb851.png";